<mat-card class="mt-3 mat-elevation-z0">
  <h4 class="h1 text-center">LCGPA Form</h4>
  <mat-horizontal-stepper linear completed="false" labelPosition="bottom" #stepper *ngIf="initialData">
    <mat-step label="Contact Details and General Information" [stepControl]="formGeneral">
      <div class="mt-3">
        <div>
          <div>
            <form autocomplete="off" [formGroup]="formGeneral">
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Are you filling this form for the first time ?<span class="text-danger" matTooltip="required field"> *</span><br />
                    </span>
                  </div>
                  <select class="form-control col-8" formControlName="chkFirstTime" (change)="chkFirstTimeChanged()">
                    <option value="null" disabled selected>Select</option>
                    <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                  </select>
                </div>
                <div class="row" *ngIf="formGeneral.controls['chkFirstTime'].invalid && (formGeneral.controls['chkFirstTime'].dirty || formGeneral.controls['chkFirstTime'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4" *ngIf="formGeneral.controls['chkFirstTime'].value === 'false'">
                <div>
                  <div class="input-group row">
                    <div class="input-group-prepend col-4">
                      <span>Halliburton LCGPA Form ID<span class="text-danger" matTooltip="required field"> *</span></span>
                    </div>
                    <input type="text" class="form-control" formControlName="iktvaUniqueId" placeholder="Enter form id here and click on 'Fetch Form'.." />
                    <div class="input-group-append">
                      <button class="btn btn-danger" mat-flat-button color="primary" (click)="fetchForm(formGeneral.controls['iktvaUniqueId'].value)" [disabled]="formGeneral.controls['iktvaUniqueId'].invalid">Fetch Form</button>
                    </div>
                  </div>
                  <div class="row" *ngIf="formGeneral.controls['iktvaUniqueId'].invalid && (formGeneral.controls['iktvaUniqueId'].dirty || formGeneral.controls['iktvaUniqueId'].touched)">
                    <div class="col-4"></div>
                    <div *ngIf="formGeneral.controls['iktvaUniqueId'].errors.required" class="col text-danger">
                      *required
                    </div>
                  </div>
                  <div class="row" *ngIf="oldForm && currentYear > +oldForm.Year">
                    <div class="col-4"></div>
                    <div class="col text-info">
                      This form was submitted in {{oldForm.Year}}. Resubmitting it now will be treated as a new form for {{currentYear}} and you will be provided a different LCGPA Form Id.
                    </div>
                  </div>
                </div>
                <!--<hr />-->
              </div>
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>Company Name<span class="text-danger" matTooltip="required field"> *</span></span>
                  </div>
                  <input type="text" class="form-control col-8" formControlName="companyName" pattern=".*\S.*" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['companyName'].invalid && (formGeneral.controls['companyName'].dirty || formGeneral.controls['companyName'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['companyName'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['companyName'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Commercial Registration (CR) Number
                    </span>
                  </div>
                  <input type="text" class="form-control col-8" formControlName="commercialRegistration" />
                </div>
                <!--<div class="row" *ngIf="formGeneral.controls['commercialRegistration'].invalid && (formGeneral.controls['commercialRegistration'].dirty || formGeneral.controls['commercialRegistration'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['commercialRegistration'].errors.required" class="col text-danger">
                    *required
                  </div>
                </div>-->
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Halliburton Vendor Number <br /> (For Existing Vendors)
                    </span>
                  </div>
                  <input type="text" class="form-control col-8" formControlName="halVendorNumber" />
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span class="">
                      Business Segment as per LCGPA Guidelines<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <select class="form-control col-8" formControlName="businessSegment">
                    <option value="null" disabled selected>Select</option>
                    <option *ngFor="let seg of initialData.BusinessSegments" [value]="seg.Id">{{ seg.Name }}</option>
                  </select>
                </div>
                <div class="row" *ngIf="formGeneral.controls['businessSegment'].invalid && (formGeneral.controls['businessSegment'].dirty || formGeneral.controls['businessSegment'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Description of Company Core of Business As Per CR<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <textarea type="text" rows="4" class="form-control col-8" formControlName="businessDescription" pattern=".*\S.*"></textarea>
                </div>
                <div class="row" *ngIf="formGeneral.controls['businessDescription'].invalid && (formGeneral.controls['businessDescription'].dirty || formGeneral.controls['businessDescription'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['businessDescription'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['businessDescription'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Company Address<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <div class="col-8">
                    <div class="row"><textarea type="text" rows="4" class="form-control col" formControlName="address" pattern=".*\S.*"></textarea></div>
                    <div class="row" *ngIf="formGeneral.controls['address'].invalid && (formGeneral.controls['address'].dirty || formGeneral.controls['address'].touched)">
                      <!--<div class="col-4"></div>-->
                     <div *ngIf="formGeneral.controls['address'].errors.required" class="col text-danger">
                       *required
                     </div>
                     <div *ngIf="formGeneral.controls['address'].errors.pattern" class="col text-danger">
                       *required
                     </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Company City<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="city" pattern=".*\S.*" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['city'].invalid && (formGeneral.controls['city'].dirty || formGeneral.controls['city'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['city'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['city'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Company Country<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="country" pattern=".*\S.*" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['country'].invalid && (formGeneral.controls['country'].dirty || formGeneral.controls['country'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['country'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['country'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Company Email Address<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="companyEmail" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['companyEmail'].invalid && (formGeneral.controls['companyEmail'].dirty || formGeneral.controls['companyEmail'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['companyEmail'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['companyEmail'].errors.email" class="col text-danger">
                    *valid email address expected
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Company Contact Person<span class="text-danger" matTooltip="required field"> *</span> <br />(Name of Finance Manager, LCGPA Lead or Business Development Manager)
                    </span>
                  </div>
                  <div class="col-8">
                    <div class="row"><input type="text" rows="4" class="form-control col" formControlName="companyContactPerson" pattern=".*\S.*" /></div>
                    <div class="row" *ngIf="formGeneral.controls['companyContactPerson'].invalid && (formGeneral.controls['companyContactPerson'].dirty || formGeneral.controls['companyContactPerson'].touched)">
                      <!--<div class="col-4"></div>-->
                      <div *ngIf="formGeneral.controls['companyContactPerson'].errors.required" class="col text-danger">
                        *required
                      </div>
                      <div *ngIf="formGeneral.controls['companyContactPerson'].errors.pattern" class="col text-danger">
                        *required
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Phone Number of Contact Person<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="phoneContactPerson" pattern=".*\S.*" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['phoneContactPerson'].invalid && (formGeneral.controls['phoneContactPerson'].dirty || formGeneral.controls['phoneContactPerson'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['phoneContactPerson'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['phoneContactPerson'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Email Address of Contact Person<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="emailContactPerson" />
                </div>
                <div class="row" *ngIf="formGeneral.controls['emailContactPerson'].invalid && (formGeneral.controls['emailContactPerson'].dirty || formGeneral.controls['emailContactPerson'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formGeneral.controls['emailContactPerson'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formGeneral.controls['emailContactPerson'].errors.email" class="col text-danger">
                    *valid email address expected
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Annual Revenue is more than USD(United States Dollars )$53,000,000?<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <div class="col-8">
                    <div class="row">
                      <select class="form-control col" formControlName="chkAnnualRevenue">
                        <option value="null" disabled selected>Select</option>
                        <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                      </select>
                    </div>
                    <div class="row" *ngIf="formGeneral.controls['chkAnnualRevenue'].invalid && (formGeneral.controls['chkAnnualRevenue'].dirty || formGeneral.controls['chkAnnualRevenue'].touched)">
                      <!--<div class="col-4"></div>-->
                      <div class="col text-danger">
                        *required
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Total Employees are more than 250?<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <select class="form-control col-8" formControlName="chkTotalEmployee">
                    <option value="null" disabled selected>Select</option>
                    <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                  </select>
                </div>
                <div class="row" *ngIf="formGeneral.controls['chkTotalEmployee'].invalid && (formGeneral.controls['chkTotalEmployee'].dirty || formGeneral.controls['chkTotalEmployee'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div>
                <button mat-raised-button type="button" class="btn btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
                <button mat-raised-button matStepperNext type="button" color="primary" class="btn ml-2">Next <mat-icon>navigate_next</mat-icon></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step label="Manufacturing Facilities" [stepControl]="formManufacturing">
      <div class="mt-3">
        <div>
          <div>
            <form [formGroup]="formManufacturing" autocomplete="off">
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Total Number of Employees<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="totalEmployees" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['totalEmployees'].invalid && (formManufacturing.controls['totalEmployees'].dirty || formManufacturing.controls['totalEmployees'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Total Number of National Saudi Employees<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="totalSaudiEmployees" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['totalSaudiEmployees'].invalid && (formManufacturing.controls['totalSaudiEmployees'].dirty || formManufacturing.controls['totalSaudiEmployees'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Number of Employees in Manufacturing Division<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="totalManufacturingEmployees" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['totalManufacturingEmployees'].invalid && (formManufacturing.controls['totalManufacturingEmployees'].dirty || formManufacturing.controls['totalManufacturingEmployees'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Number of Employees in Quality Division<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="totalQualityEmployees" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['totalQualityEmployees'].invalid && (formManufacturing.controls['totalQualityEmployees'].dirty || formManufacturing.controls['totalQualityEmployees'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Number of Employees in Engineering Divisions<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="totalEngineeringEmployees" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['totalEngineeringEmployees'].invalid && (formManufacturing.controls['totalEngineeringEmployees'].dirty || formManufacturing.controls['totalEngineeringEmployees'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div class="mb-4">
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Area Size of Manufacturing Division<span class="text-danger" matTooltip="required field"> *</span> <br />(In Square Meters)
                    </span>
                  </div>
                  <input type="text" rows="4" class="form-control col-8" formControlName="manufacturingDivArea" />
                </div>
                <div class="row" *ngIf="formManufacturing.controls['manufacturingDivArea'].invalid && (formManufacturing.controls['manufacturingDivArea'].dirty || formManufacturing.controls['manufacturingDivArea'].touched)">
                  <div class="col-4"></div>
                  <div class="col text-danger">
                    *required and only numeric value accepted
                  </div>
                </div>
              </div>
              <!--<hr />-->
              <div>
                <button mat-raised-button type="button" class="btn btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
                <button mat-raised-button matStepperPrevious type="button" color="accent" class="btn ml-2 btn-lg"><mat-icon>navigate_before</mat-icon> Previous</button>
                <button mat-raised-button matStepperNext type="button" color="primary" class="btn ml-2">Next <mat-icon>navigate_next</mat-icon></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </mat-step>
    <mat-step label="Certifications" [stepControl]="formCertifications">
      <div class="mt-3">
        <div>
          <form [formGroup]="formCertifications">
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you have API Certification?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkApiCertification">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formCertifications.controls['chkApiCertification'].invalid && (formCertifications.controls['chkApiCertification'].dirty || formCertifications.controls['chkApiCertification'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you have SME Certification?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkSmeCertification">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formCertifications.controls['chkSmeCertification'].invalid && (formCertifications.controls['chkSmeCertification'].dirty || formCertifications.controls['chkSmeCertification'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you have ISO Certification?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkIsoCertification">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formCertifications.controls['chkIsoCertification'].invalid && (formCertifications.controls['chkIsoCertification'].dirty || formCertifications.controls['chkIsoCertification'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you have an ERP System?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkErpSystem">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formCertifications.controls['chkErpSystem'].invalid && (formCertifications.controls['chkErpSystem'].dirty || formCertifications.controls['chkErpSystem'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div>
              <button mat-raised-button type="button" class="btn btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
              <button mat-raised-button matStepperPrevious type="button" color="accent" class="btn ml-2 btn-lg"><mat-icon>navigate_before</mat-icon> Previous</button>
              <button mat-raised-button matStepperNext type="button" color="primary" class="btn ml-2">Next <mat-icon>navigate_next</mat-icon></button>
            </div>
          </form>
        </div>
      </div>

    </mat-step>
    <mat-step label="LCGPA Status" [stepControl]="formIKTVA">
      <div class="mt-3">
        <div>
          <form [formGroup]="formIKTVA">
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Are you submitting your company's Annual LCGPA Audit Report to Saudi Aramco?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkAnnualAuditReport">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['chkAnnualAuditReport'].invalid && (formIKTVA.controls['chkAnnualAuditReport'].dirty || formIKTVA.controls['chkAnnualAuditReport'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Are you exporting goods and/or services outside of Saudi Arabia?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkExporting">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['chkExporting'].invalid && (formIKTVA.controls['chkExporting'].dirty || formIKTVA.controls['chkExporting'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you require any support from Halliburton for LCGPA score calculations?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkRequireHalSupport">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['chkRequireHalSupport'].invalid && (formIKTVA.controls['chkRequireHalSupport'].dirty || formIKTVA.controls['chkRequireHalSupport'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    What was your company's previous year LCGPA Score?
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="iktvaPreviousYearScore" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['iktvaPreviousYearScore'].invalid && (formIKTVA.controls['iktvaPreviousYearScore'].dirty || formIKTVA.controls['iktvaPreviousYearScore'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['iktvaPreviousYearScore'].errors.required" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    What was your company's revenue in current year?
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="previousYearRevenue" />
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Is your LCGPA score audited or Self-Reported?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="previousYearScoreAuditReport">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.IKTVAReportingTypes" [value]="seg.Id">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['previousYearScoreAuditReport'].invalid && (formIKTVA.controls['previousYearScoreAuditReport'].dirty || formIKTVA.controls['previousYearScoreAuditReport'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    What is your company's estimated LCGPA Score for next year?
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="currentYearEstimatedScore" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['currentYearEstimatedScore'].invalid && (formIKTVA.controls['currentYearEstimatedScore'].dirty || formIKTVA.controls['currentYearEstimatedScore'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['currentYearEstimatedScore'].errors.required" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    What is your company's estimated revenue for next year?
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="currentYearEstimatedRevenue" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['currentYearEstimatedRevenue'].invalid && (formIKTVA.controls['currentYearEstimatedRevenue'].dirty || formIKTVA.controls['currentYearEstimatedRevenue'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['currentYearEstimatedRevenue'].errors.required" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Types of Material/Services Provided<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8 services-multiselect" formControlName="servicesProvided" size="10" multiple (change)="servicesChanged($event.target.value)">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.Services" [value]="seg.Id">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row">
                <div class="col-4"></div>
                <div class="col text-info">Use Ctrl key to select multiple values</div>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['servicesProvided'].invalid && (formIKTVA.controls['servicesProvided'].dirty || formIKTVA.controls['servicesProvided'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div *ngIf="isOtherServicesVisible" class="mb-4">
              <div>
                <div class="input-group row">
                  <div class="input-group-prepend col-4">
                    <span>
                      Other Material/Services Provided<span class="text-danger" matTooltip="required field"> *</span>
                    </span>
                  </div>
                  <input type="text" class="form-control col-8" formControlName="otherServices" pattern=".*\S.*" />
                </div>
                <div class="row" *ngIf="formIKTVA.controls['otherServices'].invalid && (formIKTVA.controls['otherServices'].dirty || formIKTVA.controls['otherServices'].touched)">
                  <div class="col-4"></div>
                  <div *ngIf="formIKTVA.controls['otherServices'].errors.required" class="col text-danger">
                    *required
                  </div>
                  <div *ngIf="formIKTVA.controls['otherServices'].errors.pattern" class="col text-danger">
                    *required
                  </div>
                </div>
              </div>
              <!--<hr />-->
            </div>
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Produced Locally or Imported?<span class="text-danger" matTooltip="required field"> *</span> <br />(Material Only)
                  </span>
                </div>
                <select class="form-control col-8" formControlName="localOrImported">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.MaterialProductionTypes" [value]="seg.Id">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['localOrImported'].invalid && (formIKTVA.controls['localOrImported'].dirty || formIKTVA.controls['localOrImported'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="row input-group">
                <div class="col-4 input-group-prepend">
                  <span>
                    Upload a copy of your manufacturing profile
                  </span>
                </div>
                <div class="col-8 custom-file">
                  <input type="file" #fileUpload (click)="fileUpload.value = null" multiple class="custom-file-input" id="fileUpload" (change)="fileChange($event)"
                         accept=".xlsx,.docx,.pdf,.pptx,.zip" />
                  <label for="fileUpload" class="custom-file-label">Browse Files</label>
                </div>
              </div>
              <div class="card mt-2" *ngIf="uploadFileNames && uploadFileNames.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Files selected for upload:</h6>
                  <div class="row mb-1" *ngFor="let file of uploadFileNames">
                    <div class="col-4"><h6 class="text-muted">{{ file }}</h6></div>
                    <div class="col-1"><i class="material-icons md-18" (click)="removeFile(file)">remove_circle</i></div>
                  </div>
                </div>
              </div>
              <div class="card mt-2" *ngIf="previouslyUploadedManufacturingFiles && previouslyUploadedManufacturingFiles.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Previously Uploaded Files:</h6>
                  <div class="row mb-1" *ngFor="let file of previouslyUploadedManufacturingFiles">
                    <div class="col-6">
                      <!--<a matTooltip="Click to download" target="_blank" href="api/download/{{file.Id}}"><h6 class="text-muted">{{ file.OriginalFileName }}</h6></a>-->
                      <button mat-button color="accent" matTooltip="Click to download" (click)="downloadFile(file.Id, file.OriginalFileName)">{{ file.OriginalFileName }}</button>
                    </div>
                  </div>
                  <div class="row" *ngIf="previouslyUploadedManufacturingFiles && previouslyUploadedManufacturingFiles.length > 0 && formMode==='new'">
                    <!--user fetched form submitted in previous years. So when he clicks on submit a new form will be submitted. So we will not have previous year files
                    associated with this new form-->
                    <div class="col text-danger">As a new form will be submitted for this year, please upload appropriate files. Previously uploaded files will not be associated with new form.</div>
                  </div>
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    How much is your spend and/or percentage of localized goods and services?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <input type="text" class="form-control col-8" formControlName="spendLocalizedServices" pattern=".*\S.*" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['spendLocalizedServices'].invalid && (formIKTVA.controls['spendLocalizedServices'].dirty || formIKTVA.controls['spendLocalizedServices'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['spendLocalizedServices'].errors.required" class="col text-danger">
                  *required
                </div>
                <div *ngIf="formIKTVA.controls['spendLocalizedServices'].errors.pattern" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    How much is your spend and/or percentage of compensation paid to Saudi nationals?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="spendCompensationSaudiNationals" pattern=".*\S.*" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['spendCompensationSaudiNationals'].invalid && (formIKTVA.controls['spendCompensationSaudiNationals'].dirty || formIKTVA.controls['spendCompensationSaudiNationals'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['spendCompensationSaudiNationals'].errors.required" class="col text-danger">
                  *required
                </div>
                <div *ngIf="formIKTVA.controls['spendCompensationSaudiNationals'].errors.pattern" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    How much is your spend and/or percentage on training and development for Saudi nationals?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="spendTrainingSaudiNationals" pattern=".*\S.*" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['spendTrainingSaudiNationals'].invalid && (formIKTVA.controls['spendTrainingSaudiNationals'].dirty || formIKTVA.controls['spendTrainingSaudiNationals'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['spendTrainingSaudiNationals'].errors.required" class="col text-danger">
                  *required
                </div>
                <div *ngIf="formIKTVA.controls['spendTrainingSaudiNationals'].errors.pattern" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    How much is your spend and/or percentage on supplier development?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <input type="text" rows="4" class="form-control col-8" formControlName="spendSupplierDevelopment" pattern=".*\S.*" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['spendSupplierDevelopment'].invalid && (formIKTVA.controls['spendSupplierDevelopment'].dirty || formIKTVA.controls['spendSupplierDevelopment'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['spendSupplierDevelopment'].errors.required" class="col text-danger">
                  *required
                </div>
                <div *ngIf="formIKTVA.controls['spendSupplierDevelopment'].errors.pattern" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    How much is your spend and/or percentage on research & development?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <input type="text" class="form-control col-8" formControlName="spendResearch" pattern=".*\S.*" />
              </div>
              <div class="row" *ngIf="formIKTVA.controls['spendResearch'].invalid && (formIKTVA.controls['spendResearch'].dirty || formIKTVA.controls['spendResearch'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['spendResearch'].errors.required" class="col text-danger">
                  *required
                </div>
                <div *ngIf="formIKTVA.controls['spendResearch'].errors.pattern" class="col text-danger">
                  *required
                </div>
              </div>
            </div>

            <div class="mb-4">
              <div class="row input-group">
                <div class="col-4 input-group-prepend">
                  <span>
                    Upload a copy of LCGPA plan for your company in the next 3-5 years<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <div class="col-8 custom-file">
                  <input multiple type="file" #fileUploadIktvaPlan (click)="fileUploadIktvaPlan.value = null" class="custom-file-input" id="fileUploadIktvaPlan" (change)="fileChangeIktvaPlan($event)"
                         accept=".xlsx,.docx,.pdf,.pptx,.zip" formControlName="iktvaFileUpload" (blur)="formIKTVA.controls['iktvaFileUpload'].updateValueAndValidity({ onlySelf: true })" />
                  <label for="fileUploadIktvaPlan" class="custom-file-label">Browse Files</label>
                </div>
              </div>
              <div class="row" *ngIf="formIKTVA.controls['iktvaFileUpload'].invalid && (formIKTVA.controls['iktvaFileUpload'].dirty || formIKTVA.controls['iktvaFileUpload'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formIKTVA.controls['iktvaFileUpload'].errors.iktvaPlanFileRequired" class="col text-danger">
                  *required
                </div>
              </div>
              <div class="card mt-2" *ngIf="uploadFilesIktvaPlanNames && uploadFilesIktvaPlanNames.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Files selected for upload:</h6>
                  <div class="row mb-1" *ngFor="let file of uploadFilesIktvaPlanNames">
                    <div class="col-4"><h6 class="text-muted">{{ file }}</h6></div>
                    <div class="col-1"><i class="material-icons md-18" (click)="removeIktvaPlanFile(file)">remove_circle</i></div>
                  </div>
                </div>
              </div>
              <div class="card mt-2" *ngIf="previouslyUploadedIktvaPlanFiles && previouslyUploadedIktvaPlanFiles.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Previously Uploaded Files:</h6>
                  <div class="row mb-1" *ngFor="let file of previouslyUploadedIktvaPlanFiles">
                    <div class="col-6">
                      <!--<a matTooltip="Click to download" target="_blank" href="api/download/{{file.Id}}"><h6 class="text-muted">{{ file.OriginalFileName }}</h6></a>-->
                      <button mat-button color="accent" matTooltip="Click to download" (click)="downloadFile(file.Id, file.OriginalFileName)">{{ file.OriginalFileName }}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="previouslyUploadedIktvaPlanFiles && previouslyUploadedIktvaPlanFiles.length > 0 && formMode==='new'">
                <!--user fetched form submitted in previous years. So when he clicks on submit a new form will be submitted. So we will not have previous year files
                associated with this new form-->
                <div class="col text-danger">As a new form will be submitted for this year, please upload appropriate files. Previously uploaded files will not be associated with new form.</div>
              </div>
            </div>
            <!--<hr />-->
            <div>
              <button mat-raised-button type="button" class="btn btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
              <button mat-raised-button matStepperPrevious type="button" color="accent" class="btn ml-2 btn-lg"><mat-icon>navigate_before</mat-icon> Previous</button>
              <button mat-raised-button type="button" color="primary" class="btn ml-2" (click)="goToNextFromLcgpaStatus(stepper)">Next <mat-icon>navigate_next</mat-icon></button>
            </div>
          </form>
        </div>
      </div>
    </mat-step>
    <mat-step label="Sourcing of Raw Materials, Products and Services" [stepControl]="formSourcing">
      <div class="mt-3">
        <div>
          <form autocomplete="off" [formGroup]="formSourcing">
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span>
                    Which are the major contracts/companies you are currently engaged with?
                  </span>
                </div>
                <textarea type="text" rows="4" class="form-control col-8" formControlName="majorContracts"></textarea>
              </div>
              <div class="row" *ngIf="formSourcing.controls['majorContracts'].invalid && (formSourcing.controls['majorContracts'].dirty || formSourcing.controls['majorContracts'].touched)">
                <div class="col-4"></div>
                <div *ngIf="formSourcing.controls['majorContracts'].errors.required" class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Source of Raw Material
                  </span>
                </div>
                <select class="form-control col-8" formControlName="rawMaterialSource">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.RawMaterialSources" [value]="seg.Id">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formSourcing.controls['rawMaterialSource'].invalid && (formSourcing.controls['rawMaterialSource'].dirty || formSourcing.controls['rawMaterialSource'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Do you have a Quality Management System?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkQualityManagement">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formSourcing.controls['chkQualityManagement'].invalid && (formSourcing.controls['chkQualityManagement'].dirty || formSourcing.controls['chkQualityManagement'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="input-group row">
                <div class="input-group-prepend col-4">
                  <span class="">
                    Are you conducting an Internal Quality Audit?<span class="text-danger" matTooltip="required field"> *</span>
                  </span>
                </div>
                <select class="form-control col-8" formControlName="chkInternalQualityAudit">
                  <option value="null" disabled selected>Select</option>
                  <option *ngFor="let seg of initialData.YesNoTypes" [value]="seg.Value">{{ seg.Name }}</option>
                </select>
              </div>
              <div class="row" *ngIf="formSourcing.controls['chkInternalQualityAudit'].invalid && (formSourcing.controls['chkInternalQualityAudit'].dirty || formSourcing.controls['chkInternalQualityAudit'].touched)">
                <div class="col-4"></div>
                <div class="col text-danger">
                  *required
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="mb-4">
              <div class="row input-group">
                <div class="col-4 input-group-prepend">
                  <span>
                    Upload a copy of your Internal Quality Audit Report
                  </span>
                </div>
                <div class="col-8 custom-file">
                  <input multiple type="file" #fileUploadAuditReport (click)="fileUploadAuditReport.value = null" class="custom-file-input" id="fileUploadAuditReport" (change)="fileChangeAuditReport($event)"
                         accept=".xlsx,.docx,.pdf,.pptx,.zip" />
                  <label for="fileUploadAuditReport" class="custom-file-label">Browse Files</label>
                </div>
              </div>
              <div class="card mt-2" *ngIf="uploadFileAuditReportNames && uploadFileAuditReportNames.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Files selected for upload:</h6>
                  <div class="row mb-1" *ngFor="let file of uploadFileAuditReportNames">
                    <div class="col-4"><h6 class="text-muted">{{ file }}</h6></div>
                    <div class="col-1"><i class="material-icons md-18" (click)="removeAuditReportFile(file)">remove_circle</i></div>
                  </div>
                </div>
              </div>
              <div class="card mt-2" *ngIf="previouslyUploadedQualityFiles && previouslyUploadedQualityFiles.length > 0">
                <div class="card-body">
                  <h6 class="card-title">Previously Uploaded Files:</h6>
                  <div class="row mb-1" *ngFor="let file of previouslyUploadedQualityFiles">
                    <div class="col-6">
                      <!--<a matTooltip="Click to download" target="_blank" href="api/download/{{file.Id}}"><h6 class="text-muted">{{ file.OriginalFileName }}</h6></a>-->
                      <button mat-button color="accent" matTooltip="Click to download" (click)="downloadFile(file.Id, file.OriginalFileName)">{{ file.OriginalFileName }}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="previouslyUploadedQualityFiles && previouslyUploadedQualityFiles.length > 0 && formMode==='new'">
                <!--user fetched form submitted in previous years. So when he clicks on submit a new form will be submitted. So we will not have previous year files
                associated with this new form-->
                <div class="col text-danger">As a new form will be submitted for this year, please upload appropriate files. Previously uploaded files will not be associated with new form.</div>
              </div>
            </div>
            <!--<hr />-->
            <div>
              <button mat-raised-button type="button" class="btn btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
              <button mat-raised-button matStepperPrevious type="button" color="accent" class="btn ml-2 btn-lg"><mat-icon>navigate_before</mat-icon> Previous</button>
              <button mat-raised-button matStepperNext type="button" color="primary" class="btn ml-2">Next <mat-icon>navigate_next</mat-icon></button>
            </div>
          </form>
        </div>
      </div>
    </mat-step>
    <mat-step label="Preview and Submit" class="text-break">
      <div class="mt-3">
        <div class="row">
          <div class="col-10">
          </div>
          <div class="col-2 text-right">
            <mat-icon style="cursor:pointer" matTooltip="Expand All" (click)="accordion.openAll()">add_circle</mat-icon>
            <mat-icon style="cursor:pointer" matTooltip="Contract All" (click)="accordion.closeAll()">remove_circle</mat-icon>
          </div>
        </div>
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><div class="h6">1. Contact Details and General Information</div></mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div>
                <div>
                  <!--add all the fields here-->
                  <div class="row">
                    <div class="col-4">
                      Company Name:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['companyName'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Commercial Registration (CR) Number:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['commercialRegistration'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Halliburton Vendor Number: <br /> (For Existing Vendors)
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['halVendorNumber'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Business Segment as per LCGPA Guidelines:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['businessSegment'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Description of Company Core of Business As Per CR:
                    </div>
                    <div class="col-8 text-break" style="white-space:pre-line">
                      {{ formGeneral.controls['businessDescription'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Company Address:
                    </div>
                    <div class="col-8 text-break" style="white-space:pre-line">
                      {{ formGeneral.controls['address'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Company City:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['city'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Company Country:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['country'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Company Email Address:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['companyEmail'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Company Contact Person:<br />(Name of Finance Manager, LCGPA Lead or Business Development Manager)
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['companyContactPerson'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Phone Number of Contact Person:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['phoneContactPerson'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Email Address of Contact Person:
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['emailContactPerson'].value }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Annual Revenue is more than USD(United States Dollars) $53,000,000?
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['chkAnnualRevenue'].value === "true" ? "Yes" : "No" }}
                    </div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Total Employees are more than 250?
                    </div>
                    <div class="col-8">
                      {{ formGeneral.controls['chkTotalEmployee'].value === "true" ? "Yes" : "No" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><div class="h6">2. Manufacturing Facilities</div></mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div>
                <div>
                  <div class="row">
                    <div class="col-4">
                      Total Number of Employees:
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['totalEmployees'].value }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Total Number of National Saudi Employees:
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['totalSaudiEmployees'].value }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Number of Employees in Manufacturing Division:
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['totalManufacturingEmployees'].value }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Number of Employees in Quality Division:
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['totalQualityEmployees'].value }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Number of Employees in Engineering Divisions:
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['totalEngineeringEmployees'].value }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Area Size of Manufacturing Division:<br />(In Square Meters)
                    </div>
                    <div class="col-8">{{ formManufacturing.controls['manufacturingDivArea'].value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><div class="h6">3. Certifications</div></mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div>
                <div>
                  <div class="row">
                    <div class="col-4">
                      Do you have API Certification?
                    </div>
                    <div class="col-8">{{ formCertifications.controls['chkApiCertification'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Do you have SME Certification?
                    </div>
                    <div class="col-8">{{ formCertifications.controls['chkSmeCertification'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Do you have ISO Certification?
                    </div>
                    <div class="col-8">{{ formCertifications.controls['chkIsoCertification'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                  <!--<hr />-->
                  <div class="row">
                    <div class="col-4">
                      Do you have an ERP System?
                    </div>
                    <div class="col-8">{{ formCertifications.controls['chkErpSystem'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><div class="h6">4. LCGPA Status</div></mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div>
                <div>
                  <div class="row">
                    <div class="col-4">
                      Are you submitting your company's Annual LCGPA Audit Report to Saudi Aramco?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['chkAnnualAuditReport'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      Are you exporting goods and/or services outside of Saudi Arabia?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['chkExporting'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      Do you require any support from Halliburton for LCGPA score calculations?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['chkRequireHalSupport'].value === "true" ? "Yes" : "No" }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      What was your company's previous year LCGPA Score?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['iktvaPreviousYearScore'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      What was your company's revenue in current year?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['previousYearRevenue'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      Is your LCGPA score audited or Self-Reported?
                    </div>
                    <div class="col-8">{{ getReportingType(+formIKTVA.controls['previousYearScoreAuditReport'].value) }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      What is your company's estimated LCGPA Score for next year?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['currentYearEstimatedScore'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      What is your company's estimated revenue for next year?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['currentYearEstimatedRevenue'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      Type of Material/Services Provided:
                    </div>
                    <div class="col-8">{{ getServicesProvided(formIKTVA.controls['servicesProvided'].value) }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div *ngIf="isOtherServicesVisible">
                  <div>
                    <div class="row">
                      <div class="col-4">
                        Other Material/Services Provided:
                      </div>
                      <div class="col-8">{{ formIKTVA.controls['otherServices'].value }}</div>
                    </div>
                  </div>
                  <!--<hr />-->
                </div>
                <div>
                  <div class="row">
                    <div class="col-4">
                      Produced Locally or Imported? <br />(Material Only)
                    </div>
                    <div class="col-8">{{ getMateriaqlProductionType(+formIKTVA.controls['localOrImported'].value) }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      Uploaded copy of your manufacturing profile:
                    </div>
                    <div class="col-8">
                      <div *ngFor="let file of uploadFileNames">
                        {{ file }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      How much is your spend and/or percentage of localized goods and services?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['spendLocalizedServices'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      How much is your spend and/or percentage of compensation paid to Saudi nationals?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['spendCompensationSaudiNationals'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      How much is your spend and/or percentage on training and development for Saudi nationals?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['spendTrainingSaudiNationals'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      How much is your spend and/or percentage on supplier development?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['spendSupplierDevelopment'].value }}</div>
                  </div>
                </div>
                <!--<hr />-->
                <div>
                  <div class="row">
                    <div class="col-4">
                      How much is your spend and/or percentage on research & development?
                    </div>
                    <div class="col-8">{{ formIKTVA.controls['spendResearch'].value }}</div>
                  </div>
                </div>
                <!--<!--<hr />-->-->
                <!--<div>
                  <div class="row">
                    <div class="col-4">
                      Please describe the IKTVA plan for your company in the next 3-5 years:
                    </div>
                    <div class="col-8 text-break" style="white-space:pre-line">{{ formIKTVA.controls['iktvaPlan'].value }}</div>
                  </div>
                </div>-->
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title><div class="h6">5. Sourcing of Raw Materials, Products and Services</div></mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="row">
                <div class="col-4">
                  Which are the major contracts/companies you are currently engaged with?
                </div>
                <div class="col-8 text-break" style="white-space:pre-line">{{ formSourcing.controls['majorContracts'].value }}</div>
              </div>
              <!--<hr />-->
              <div class="row">
                <div class="col-4">
                  Source of Raw Material:
                </div>
                <div class="col-8">{{ getSourceOfRawMaterial(+formSourcing.controls['rawMaterialSource'].value) }}</div>
              </div>
              <!--<hr />-->
              <div class="row">
                <div class="col-4">
                  Do you have a Quality Management System?
                </div>
                <div class="col-8">{{ formSourcing.controls['chkQualityManagement'].value === "true" ? "Yes" : "No" }}</div>
              </div>
              <!--<hr />-->
              <div class="row">
                <div class="col-4">
                  Are you conducting an Internal Quality Audit?
                </div>
                <div class="col-8">{{ formSourcing.controls['chkInternalQualityAudit'].value === "true" ? "Yes" : "No" }}</div>
              </div>
              <!--<hr />-->
              <div>
                <div class="row">
                  <div class="col-4">
                    Uploaded copy of your Internal Quality Audit Report:
                  </div>
                  <div class="col-8">
                    <div *ngFor="let file of uploadFileAuditReportNames">
                      {{ file }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="mt-2">
          <button mat-raised-button type="button" class="btn btn-secondary  btn-lg" matTooltip="Click to reset form." (click)="resetStepper(stepper)">Cancel</button>
          <button mat-raised-button matStepperPrevious type="button" color="accent" class="btn btn-secondary ml-2 btn-lg">Previous</button>
          <button mat-raised-button type="button" color="primary" class="btn ml-2" [disabled]="!checkIfFormIsValid()" (click)="submitForm()"><mat-icon>save</mat-icon> Submit</button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</mat-card>
<ngx-spinner bdOpacity=0.9
             bdColor="#333"
             size="medium"
             color="#fff"
             type="ball-clip-rotate"
             [fullScreen]="true">
  <p style="color: white"> {{spinnerText}} </p>
</ngx-spinner>
